import { getS2TLang, getS2TLangs, S2TSaveLang } from "@/utils/utils";
import {Icon} from "@/components/Icon.tsx";
import Select from "react-select";
import ContentEditable from "react-contenteditable";
import React, { useEffect, useRef } from "react";
import { ChatBotProps } from "@/components/dialog/types";

{/*@ts-ignore*/}
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { forceScrolling } from "@/components/dialog/helpers";

const S2TLangs = getS2TLangs();

interface InputFieldProps {
  chat: ChatBotProps;
  stopGenerating: any;
  sendQuestion: any;
  progress: boolean;
}

const InputField = (props: InputFieldProps) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    finalTranscript,
  } = useSpeechRecognition();
  let S2TTextContainerRef = useRef(null);

  const [showS2TArea, setShowS2TArea] = React.useState(false);
  const [question, setQuestion] = React.useState("");
  const [S2TText, setS2TText] = React.useState("");

  useEffect(() => {
    if (finalTranscript !== "") {
      setS2TText((text) => {
        return `${text} ${finalTranscript}`;
      });
      resetTranscript();
    }
  }, [finalTranscript, resetTranscript]);

  useEffect(() => {
    forceScrolling(S2TTextContainerRef);
  }, [S2TText, transcript, showS2TArea]);

  return (
    <div>
      <div className="pt-2 pr-2">
        {!props.progress &&
          props.chat.design.initialQuestions
            .split("\n")
            .filter((line: string) => {
              return !!line;
            })
            .map((q: string, index: number) => {
              return (
                <div
                  key={index}
                  className="ml-2 mb-2 bg-gray-100  hover:bg-gray-200 text-black-700 text-sm py-2 px-3 rounded-lg inline-block cursor-pointer"
                  onClick={() => {
                    props.sendQuestion(q);
                  }}
                >
                  {q}
                </div>
              );
            })}

        {!!props.progress && (
          <div className="flex justify-center p-2">
            <button
              className="py-1 px-8 bg-slate-200 hover:bg-slate-300 rounded bg-opacity-70"
              onClick={() => {
                props.stopGenerating(true);
              }}
            >
              Stop
            </button>
          </div>
        )}
      </div>
      <div className="relative flex items-center border-t px-2 py-2">
        {!showS2TArea && (
          <div className="w-full">
            <input
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                  //  && (e.metaKey || e.ctrlKey)
                  props.sendQuestion(question);
                  setQuestion("");
                }
              }}
              value={question}
              onChange={(event) => {
                setQuestion(event.target.value);
              }}
              className={
                "w-full rounded-lg border border-gray-300 outline-0 p-2 " +
                (props.chat.design.voiceToText &&
                browserSupportsSpeechRecognition
                  ? "!pr-[5.5rem]"
                  : "!pr-[3rem]")
              }
              type="text"
              placeholder="Your message..."
            />
            {props.chat.design.voiceToText &&
              browserSupportsSpeechRecognition && (
                <button
                  aria-label="Send message"
                  className="gialog-input-btn p-2 absolute right-12 hover:bg-gray-100"
                  onClick={() => {
                    setShowS2TArea((state: boolean) => {
                      return !state;
                    });
                    SpeechRecognition.startListening({
                      language: getS2TLang(props.chat.token),
                      continuous: true,
                    });
                  }}
                >
                  <Icon
                    className="gialog-input-icon icon-default"
                    icon="fluent:mic-16-regular"
                    width="25"
                  />
                  <Icon
                    className="gialog-input-icon icon-hovered"
                    icon="fluent:mic-16-filled"
                    width="25"
                  />
                </button>
              )}
            <button
              aria-label="Send message"
              className="gialog-input-btn p-2 absolute right-2 rounded-r-lg hover:bg-gray-100"
              onClick={() => {
                props.sendQuestion(question);
                setQuestion("");
              }}
            >
              <Icon
                className="gialog-input-icon icon-default"
                icon="fluent:send-24-regular"
                width="25"
              />
              <Icon
                className="gialog-input-icon icon-hovered"
                icon="fluent:send-24-filled"
                width="25"
              />
            </button>
          </div>
        )}

        {showS2TArea && (
          <div className="w-full bottom-0 left-0 bg-white z-10">
            <div className="flex items-center justify-between rounded-t-lg border-[1px] border-b-0 border-gray-200 py-1 bg-slate-50">
              <div className="flex-1 px-1">
                <Select
                  className="react-select"
                  classNamePrefix="select"
                  defaultValue={S2TLangs.find((item) => {
                    return item.value === getS2TLang(props.chat.token);
                  })}
                  options={S2TLangs}
                  onChange={(e) => {
                    S2TSaveLang(props.chat.token, e.value);
                    SpeechRecognition.stopListening().then(() => {
                      SpeechRecognition.startListening({
                        language: getS2TLang(props.chat.token),
                        continuous: true,
                      });
                    });
                  }}
                />
              </div>
              <div>
                <button
                  aria-label="Send message"
                  className="gialog-input-btn p-2 right-[4.6rem]"
                  onClick={() => {
                    setS2TText("");
                    resetTranscript();
                  }}
                >
                  <Icon
                    className="gialog-input-icon icon-default"
                    icon="fluent:delete-lines-20-regular"
                    width="25"
                  />
                  <Icon
                    className="gialog-input-icon icon-hovered"
                    icon="fluent:delete-lines-20-filled"
                    width="25"
                  />
                </button>
                <button
                  aria-label="Send message"
                  className={
                    "gialog-input-btn p-2 right-[4.6rem] " +
                    (listening ? "text-red-600 filling" : "")
                  }
                  onClick={() => {
                    listening
                      ? SpeechRecognition.stopListening()
                      : SpeechRecognition.startListening({
                          language: getS2TLang(props.chat.token),
                          continuous: true,
                        });
                  }}
                >
                  <Icon
                    className="gialog-input-icon icon-default"
                    icon="fluent:mic-16-regular"
                    width="25"
                  />
                  <Icon
                    className="gialog-input-icon icon-hovered"
                    icon="fluent:mic-16-filled"
                    width="25"
                  />
                </button>
                <button
                  aria-label="Send message"
                  className={
                    "gialog-input-btn p-2 right-8 " + (S2TText ? "filling" : "")
                  }
                  onClick={async () => {
                    if (listening) {
                      SpeechRecognition.stopListening();
                    }
                    setTimeout(() => {
                      props.sendQuestion(S2TText);
                      setS2TText("");
                      resetTranscript();
                    }, 200);
                  }}
                >
                  <Icon
                    className="gialog-input-icon icon-default"
                    icon="fluent:send-24-regular"
                    width="25"
                  />
                  <Icon
                    className="gialog-input-icon icon-hovered"
                    icon="fluent:send-24-filled"
                    width="25"
                  />
                </button>
              </div>
            </div>
            <ContentEditable
              innerRef={S2TTextContainerRef}
              className="p-2 rounded-b-lg h-24 border-[1px] border-t-0 border-gray-200 overflow-y-auto overflow-x-hidden outline-0"
              html={`<span>${S2TText}</span><span class="ml-2 py-1 bg-slate-100">${transcript}</span>`} // innerHTML of the editable div
              onChange={(e) => {
                // handle innerHTML change
                if (e.currentTarget) {
                  setS2TText(e.currentTarget.innerText);
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InputField;
